import { AndroidPlatform } from './platforms/android';
import { IOSPlatform } from './platforms/ios';
import { WebPlatform } from './platforms/web';
import { ConfigLoader } from './core/config';
import { FlavorHelper } from './core/flavor-helper';
import { SplashConfig } from './types/config';

export * from './types/config';
export { SplashScreen } from './controllers/splash-screen';

export class SplashGenerator {
  private androidPlatform: AndroidPlatform;
  private iosPlatform: IOSPlatform;
  private webPlatform: WebPlatform;

  constructor(flavorHelper: FlavorHelper) {
    this.androidPlatform = new AndroidPlatform(flavorHelper);
    this.iosPlatform = new IOSPlatform(flavorHelper);
    this.webPlatform = new WebPlatform(flavorHelper);
  }

  async generate(config: SplashConfig): Promise<void> {
    const { android = true, ios = true, web = true } = config;

    const tasks: Promise<void>[] = [];

    if (android) {
      tasks.push(this.androidPlatform.generateSplash(config));
    }

    if (ios) {
      tasks.push(this.iosPlatform.generateSplash(config));
    }

    if (web) {
      tasks.push(this.webPlatform.generateSplash(config));
    }

    await Promise.all(tasks);
  }

  async remove(): Promise<void> {
    await Promise.all([
      this.androidPlatform.removeSplash(),
      this.iosPlatform.removeSplash(),
      this.webPlatform.removeSplash(),
    ]);
  }
}

export async function generateSplash(
  config?: string | SplashConfig,
  flavor?: string
): Promise<void> {
  let splashConfig: SplashConfig;

  if (typeof config === 'string') {
    splashConfig = await ConfigLoader.loadConfig(config, flavor);
  } else if (config) {
    splashConfig = config;
  } else {
    splashConfig = await ConfigLoader.loadConfig(undefined, flavor);
  }

  const flavorHelper = new FlavorHelper(flavor);
  const generator = new SplashGenerator(flavorHelper);
  await generator.generate(splashConfig);
}

export async function removeSplash(flavor?: string): Promise<void> {
  const flavorHelper = new FlavorHelper(flavor);
  const generator = new SplashGenerator(flavorHelper);
  await generator.remove();
}

export async function generateFlavorSplashes(): Promise<void> {
  const flavors = await ConfigLoader.findFlavorConfigs();

  for (const flavor of flavors) {
    console.log(`Generating splash screen for flavor: ${flavor}`);
    await generateSplash(undefined, flavor);
  }
}
